import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { usePasswordValidation } from '../../UserAdministrationContainer/lib/hooks/usePasswordValidation';
import { PasswordValidationComponent } from './passwordValidationComponent';

interface IProps {
  onSubmit: (e) => Promise<void>;
  showNotificationMessage: boolean;
  changePasswordNotification: string;
  username: string;
  confirmationCode: string;
  onChange: (e) => void;
  password: string;
  setPassword: (e) => void;
  confirmationPassword: string;
  setConfirmationPassword: (e) => void;
  showDoneButton: boolean;
  onClick: (e) => void;
  disabled: boolean;
  resetPasswordError: boolean;
  disableConfirmationCode: boolean;
}

export const ResetPasswordComponent = (props: IProps) => {
  const {
    disabled,
    onChange,
    changePasswordNotification,
    username,
    setPassword,
    confirmationPassword,
    onSubmit,
    confirmationCode,
    onClick,
    showNotificationMessage,
    showDoneButton,
    setConfirmationPassword,
    password,
    resetPasswordError,
    disableConfirmationCode,
  } = props;

  const [isValid, setValidForm] = useState(false);
  const [lowerCase, match, specialChar, upperCase, validLength, numericChar] =
    usePasswordValidation({
      firstPassword: password,
      secondPassword: confirmationPassword,
    });

  useEffect(() => {
    setValidForm(validLength && upperCase && lowerCase && specialChar && numericChar);
  });

  return (
    <Card>
      <Form onSubmit={onSubmit} noValidate>
        <CardBody>
          <h3>Change Password</h3>
          {(!resetPasswordError && !disableConfirmationCode) || showNotificationMessage &&
            <ul
              style={{
                backgroundColor: '#ff5800',
                padding: '10px',
                color: '#fff',
                fontWeight: 'bold',
              }}
            >
              {showNotificationMessage ? (
                <li style={{ backgroundColor: '#FF5800' }}>
                  {changePasswordNotification}
                </li>
              ) : null}
            </ul>
          }
          {(!resetPasswordError && !disableConfirmationCode) &&
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Username</Label>
                  <Input type="text" value={username} readOnly />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Confirmation Code</Label>
                  <Input value={confirmationCode} onChange={onChange} />
                </FormGroup>
              </Col>
            </Row>
          }
          {!resetPasswordError &&
            <PasswordValidationComponent
              password={password}
              setPassword={setPassword}
              confirmationPassword={confirmationPassword}
              setConfirmationPassword={setConfirmationPassword}
              isValid={isValid}
              match={match}
              specialChar={specialChar}
              upperCase={upperCase}
              lowerCase={lowerCase}
              validLength={validLength}
              numericChar={numericChar}
            />
          }
        </CardBody>
        {!resetPasswordError &&
          <CardFooter>
            {showDoneButton ? (
              <Button onClick={onClick}>Done</Button>
            ) : (
              <Button color="danger" disabled={disabled || !isValid || !match}>
                {disabled ? (
                  <>
                    <span>Submitting...&nbsp;</span>
                    <i className="fas fa-fw fa-cog fa-spin" />
                  </>
                ) : (
                  <>
                    <span>Submit&nbsp;</span>
                    <i className="fas fa-fw fa-paper-plane" />
                  </>
                )}
              </Button>
            )}
          </CardFooter>
        }
      </Form>
    </Card>
  );
};
